// 设置localStorage
function saveData(name, data) {
    localStorage.setItem(name, JSON.stringify(data));
}
// 读取localStorage
function getData(name) {
    var data = localStorage.getItem(name);
    return data && JSON.parse(data);
}
// 设置session
function setSession(name, value) {
    sessionStorage.setItem(name, JSON.stringify(value));
}
// 读取session
function getSession(name) {
    var data = sessionStorage.getItem(name);
    return data && JSON.parse(data);
}
// 清除storage
function removeStorage(name, type) {
    type['removeItem'](name);
}
export { saveData, getData, setSession, getSession, removeStorage };
